import { render, staticRenderFns } from "./UserMain.vue?vue&type=template&id=0ae3f124"
import script from "./UserMain.vue?vue&type=script&lang=js"
export * from "./UserMain.vue?vue&type=script&lang=js"
import style0 from "./UserMain.vue?vue&type=style&index=0&id=0ae3f124&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports